import "./ditu.js"
function initMap(){
    createMap();//创建地图
    setMapEvent();//设置地图事件
    addMapOverlay();//向地图添加覆盖物
    addMarker();//向地图中添加marker
  }
  function createMap(){ 
    map = new BMap.Map("map"); //在百度地图容器中创建一个地图   
    map.centerAndZoom(new BMap.Point(123.489964,41.703701),17);////定义一个中心点坐标
  }
  function setMapEvent(){
    map.enableScrollWheelZoom();//启用地图滚轮放大缩小
    map.enableKeyboard();//启用键盘上下左右键移动地图
    map.enableDragging();//启用地图拖拽事件，默认启用(可不写)
    map.enableDoubleClickZoom();//启用鼠标双击放大，默认启用(可不写)
  }
  function addClickHandler(target,window){
    target.addEventListener("click",function(){
      target.openInfoWindow(window);
    });
  }
  function addMapOverlay(){
    var markers = [
      {content:"",title:"",imageOffset: {width:-46,height:-21},position:{lat:23.133447,lng:113.233998}}
    ];
    for(var index = 0; index < markers.length; index++ ){
      var point = new BMap.Point(markers[index].position.lng,markers[index].position.lat);
      var marker = new BMap.Marker(point,{icon:new BMap.Icon("http://map.baidu.com/image/us_mk_icon.png",new BMap.Size(20,25),{
        imageOffset: new BMap.Size(markers[index].imageOffset.width,markers[index].imageOffset.height)
      })});
      var label = new BMap.Label(markers[index].title,{offset: new BMap.Size(25,5)});
      var opts = {
        width: 200,
        title: markers[index].title,
        enableMessage: false
      };
      var infoWindow = new BMap.InfoWindow(markers[index].content,opts);
      marker.setLabel(label);
      addClickHandler(marker,infoWindow);
      map.addOverlay(marker);
    };
  }

  //标注点数组   w:21,h:21,l:0,t:0,x:6,lb:5
  var markerArr = [{title:"物产科贸大厦2301",content:"我的备注",point:"123.433396|41.774963",isOpen:0,icon:{w:42,h:25,l:-20,t:275,x:6,lb:5}}
  ];
  //创建marker
  function addMarker(){
    for(var i=0;i<markerArr.length;i++){
        var json = markerArr[i];
        var p0 = json.point.split("|")[0];
        var p1 = json.point.split("|")[1];
        var point = new BMap.Point(p0,p1);
  var iconImg = createIcon(json.icon);
        var marker = new BMap.Marker(point,{icon:iconImg});
  var iw = createInfoWindow(i);
  var label = new BMap.Label(json.title,{"offset":new BMap.Size(json.icon.lb-json.icon.x+10,-20)});
  marker.setLabel(label);
        map.addOverlay(marker);
        label.setStyle({
                    borderColor:"#808080",
                    color:"#333",
                    cursor:"pointer"
        });
  
  (function(){
    var index = i;
    var _iw = createInfoWindow(i);
    var _marker = marker;
    _marker.addEventListener("click",function(){
        this.openInfoWindow(_iw);
      });
      _iw.addEventListener("open",function(){
        _marker.getLabel().hide();
      })
      _iw.addEventListener("close",function(){
        _marker.getLabel().show();
      })
    label.addEventListener("click",function(){
        _marker.openInfoWindow(_iw);
      })
    if(!!json.isOpen){
      label.hide();
      _marker.openInfoWindow(_iw);
    }
  })()
    }
  }
  //创建InfoWindow
  function createInfoWindow(i){
    var json = markerArr[i];
    var iw = new BMap.InfoWindow("<b class='iw_poi_title' title='" + json.title + "'>" + json.title + "</b><div class='iw_poi_content'>"+json.content+"</div>");
    return iw;
}
//创建一个Icon
function createIcon(json){//http://map.baidu.com/image/us_mk_icon.png
  
    var icon = new BMap.Icon("http://api.map.baidu.com/img/markers.png", new BMap.Size(json.w,json.h),{imageOffset: new BMap.Size(-json.l,-json.t),infoWindowOffset:new BMap.Size(json.lb+5,1),offset:new BMap.Size(json.x,json.h),imageSize:new BMap.Size(42,325)})
    return icon;
}

  //向地图添加控件
  function addMapControl(){
    var scaleControl = new BMap.ScaleControl({anchor:BMAP_ANCHOR_BOTTOM_LEFT});
    scaleControl.setUnit(BMAP_UNIT_IMPERIAL);
    map.addControl(scaleControl);
    var navControl = new BMap.NavigationControl({anchor:BMAP_ANCHOR_BOTTOM_LEFT,type:0});
    map.addControl(navControl);
    var overviewControl = new BMap.OverviewMapControl({anchor:BMAP_ANCHOR_BOTTOM_RIGHT,isOpen:true});
    map.addControl(overviewControl);
  }


  var map;
  export {initMap}


// WEBPACK FOOTER //
// ./src/assets/Scripts/map.js